import { NewsBanner, TopRight } from "@/assets/icon"
import { useNavigate } from 'react-router-dom'

const newsItems = [
    {
        category: "Platform & Campsite Updates",
        date: "2025.10.7",
        title: "New Trails Unlocked: Explore Two Fresh Campsites Near Plover Cove!"
    },
    {
        category: "Events & Community",
        date: "2025.10.6",
        title: "Eco-Friendly Camping: Small Habits, Big Impact"
    },
    {
        category: "Inspiration & Lifestyle",
        date: "2025.10.3",
        title: "Weekend Escape: The Best Forest Trails Around Lau Shui Heung"
    }
];

export const NewsSection = () => {
    const navigate = useNavigate();

    return (
        <div className="px-4 sm:px-8 lg:px-16 xl:px-24 py-12">
            <div className="relative w-full rounded-[32px] overflow-hidden">
                {/* Background Image */}
                <img src={NewsBanner} className="w-full" alt="News Banner" />

                {/* Content Overlay */}
                <div className="absolute inset-0 flex flex-col justify-between items-end p-12">
                    {/* News Items List - Constrained to right side */}
                    <div className="w-full max-w-[30%] space-y-3 mt-24 mb-auto">
                        {newsItems.map((item, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-between border-t border-white/30 pt-3"
                            >
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1">
                                        <span
                                            className="px-3 py-0.5 bg-black rounded-full"
                                            style={{
                                                fontFamily: 'Inter',
                                                fontSize: '11px',
                                                fontWeight: 500,
                                                color: '#FFFFFF'
                                            }}
                                        >
                                            {item.category}
                                        </span>
                                        <span
                                            style={{
                                                fontFamily: 'Inter',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                color: '#FFFFFF'
                                            }}
                                        >
                                            {item.date}
                                        </span>
                                    </div>
                                    <p
                                        style={{
                                            fontFamily: 'Inter',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            color: '#FFFFFF',
                                            lineHeight: 1.4
                                        }}
                                    >
                                        {item.title}
                                    </p>
                                </div>
                                <img src={TopRight} alt="arrow" className="w-4 h-4 ml-3 brightness-0 invert" />
                            </div>
                        ))}
                    </div>

                        {/* View More Button */}
                        <div className="flex justify-end w-full max-w-[30%]">
                            <button
                                onClick={() => navigate('/news')}
                                className="px-8 py-3 border-2 border-white rounded-full cursor-pointer"
                                style={{
                                    fontFamily: 'Inter',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#FFFFFF'
                                }}
                            >
                                View more →
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    )
}